class ProductAddons extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    const button = event.target.closest('[data-product-addon-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const card = button.closest('[data-product-addon-card]');
    const variantId = Number(button.dataset.variantId);
    const errorElement = this.querySelector('[data-product-addon-error]');
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    const cartElement =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    const body = {
      id: variantId,
      quantity: 1
    };

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      body.sections = cartElement.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (!response.ok) throw data;

      if (cartElement && typeof cartElement.renderContents === 'function') {
        cartElement.renderContents(data);
      }

      if (card) card.remove();

      if (!this.querySelector('[data-product-addon-card]')) {
        this.hidden = true;
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;

      if (errorElement) {
        errorElement.textContent =
          error?.description || 'Could not add this item. Please try again.';
        errorElement.hidden = false;
      }
    }
  }
}

if (!customElements.get('product-addons')) {
  customElements.define('product-addons', ProductAddons);
}